import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useToast } from '../../context/ToastContext';
import Button from '../../components/Form/Button';
import Input from '../../components/Form/Input';
import './Login.css';

const Login = () => {
    const navigate = useNavigate();
    const { login } = useAuth();
    const { showToast } = useToast();
    const [formData, setFormData] = useState({
        email: '',
        password: '',
    });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value,
        }));
        // Clear error when user starts typing
        if (error) setError('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        // Validate inputs
        if (!formData.email || !formData.password) {
            setError('Please enter both email and password');
            setLoading(false);
            return;
        }

        // Attempt login
        const result = await login(formData.email, formData.password);

        console.log("login result for redirection::", result);
        if (result.success == true) {
            showToast('OTP sent to your email!', 'success');
            // Redirect to OTP verification page
            navigate('/verify-otp');
        } else {
            setError(result.error || 'Login failed');
            showToast(result.error || 'Login failed', 'error');
        }

        setLoading(false);
    };

    return (
        <div className="login-container">
            <div className="login-card">
                <div className="login-header">
                    <div className="login-logo">
                        <img
                            src="/logo-2.png"
                            alt="Apna Pump Logo"
                            className="login-logo-icon"
                        />
                    </div>
                </div>

                <form onSubmit={handleSubmit} className="login-body">
                    <div className="login-form">
                        <Input
                            label="Email"
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            placeholder="Enter your email"
                            required
                            autoComplete="email"
                        />

                        <Input
                            label="Password"
                            type="password"
                            name="password"
                            value={formData.password}
                            onChange={handleChange}
                            placeholder="Enter your password"
                            required
                            autoComplete="current-password"
                        />

                        {error && (
                            <div className="login-error">
                                <span>⚠️</span>
                                <span>{error}</span>
                            </div>
                        )}

                        <Button
                            type="submit"
                            variant="primary"
                            size="large"
                            className="login-button"
                            loading={loading}
                        >
                            Sign In
                        </Button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default Login;
